const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Action',
        dataIndex: 'action',
        sorter: true,
        render: defaultRender,
    },
    {
        title: 'Entity',
        dataIndex: 'entityName',
        sorter: true,
        render: defaultRender,
    },
    {
        title: 'Activity',
        dataIndex: 'changes',
        render: defaultRender,
    },
    {
        title: 'Update Date',
        dataIndex: 'timestamp',
        sorter: true,
        render: defaultRender,
    }
];

export default columns;